import { z } from 'zod';
import { uuidSchema } from './common.js';
/** GET/PATCH /flags — feature flags for per-org/per-user version pinning (super_admin; Master Spec §13). */
export const patchFlagSchema = z.object({
    key: z.string().min(1).max(80),
    on: z.boolean(),
    orgId: uuidSchema.optional(),
    userId: uuidSchema.optional(),
});
export const flagSchema = z.object({
    id: uuidSchema,
    key: z.string(),
    description: z.string().nullable(),
    defaultOn: z.boolean(),
});
//# sourceMappingURL=flags.js.map